/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetAodRulesScheduledRunsQueryResponse, AuditReportsGetAodRulesScheduledRunsPathParams, AuditReportsGetAodRulesScheduledRuns401, AuditReportsGetAodRulesScheduledRuns403, AuditReportsGetAodRulesScheduledRuns404 } from "../models/AuditReportsGetAodRulesScheduledRuns";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { auditReportsGetAodRulesScheduledRuns } from "../axios/auditReportsGetAodRulesScheduledRuns";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const auditReportsGetAodRulesScheduledRunsQueryKey = (id: AuditReportsGetAodRulesScheduledRunsPathParams["id"]) => ["api-v2", { url: '/audit-reports/v1/aod-rules/:id/scheduled-runs', params: {id:id} }] as const

export type AuditReportsGetAodRulesScheduledRunsQueryKey = ReturnType<typeof auditReportsGetAodRulesScheduledRunsQueryKey>

export function auditReportsGetAodRulesScheduledRunsQueryOptions(id: AuditReportsGetAodRulesScheduledRunsPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = auditReportsGetAodRulesScheduledRunsQueryKey(id)
        return queryOptions<AuditReportsGetAodRulesScheduledRunsQueryResponse, ResponseErrorConfig<AuditReportsGetAodRulesScheduledRuns401 | AuditReportsGetAodRulesScheduledRuns403 | AuditReportsGetAodRulesScheduledRuns404>, AuditReportsGetAodRulesScheduledRunsQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return auditReportsGetAodRulesScheduledRuns(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Retrieves all future scheduled runs (enqueued jobs) for a specific AOD rule. Deprecated: Use GET /aod-runs/scheduled/rules/:ruleId instead
 * @summary Get scheduled runs for an AOD rule
 * {@link /audit-reports/v1/aod-rules/:id/scheduled-runs}
 * @deprecated
 */
export function useAuditReportsGetAodRulesScheduledRuns<TData = AuditReportsGetAodRulesScheduledRunsQueryResponse, TQueryData = AuditReportsGetAodRulesScheduledRunsQueryResponse, TQueryKey extends QueryKey = AuditReportsGetAodRulesScheduledRunsQueryKey>(id: AuditReportsGetAodRulesScheduledRunsPathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<AuditReportsGetAodRulesScheduledRunsQueryResponse, ResponseErrorConfig<AuditReportsGetAodRulesScheduledRuns401 | AuditReportsGetAodRulesScheduledRuns403 | AuditReportsGetAodRulesScheduledRuns404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? auditReportsGetAodRulesScheduledRunsQueryKey(id)
         

         const query = useQuery({
          ...auditReportsGetAodRulesScheduledRunsQueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AuditReportsGetAodRulesScheduledRuns401 | AuditReportsGetAodRulesScheduledRuns403 | AuditReportsGetAodRulesScheduledRuns404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}